<script>
import { mapActions } from 'vuex'
// import { required } from 'vuelidate/lib/validators'
import Modal from '@/components/Modal'
import ModalHeader from '@/components/ModalHeader'
import Action from '@/components/Action'
import Icon from '@/components/Icon'
import InputField from '@/components/InputField'
import { getUserErrorMessage } from '@/services/userError'

export default {
  name: 'ModalNewOrder',

  components: {
    Modal,
    ModalHeader,
    Action,
    Icon,
    InputField,
  },

  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      loading: false,
      formData: {
        name: null,
        obs: null,
      },
    }
  },

  validations: {
    formData: {
    },
  },

  methods: {
    ...mapActions('orders', ['addNewOrder']),
    ...mapActions(['setFeedback']),

    closeModal () {
      this.$emit('update:active', false)
      this.formData = {
        name: '',
        obs: '',
      }
      this.$v.$reset()
    },

    placeHolderName () {
      return `N° do pedido - ${new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}`
    },

    handleAddOrder (e) {
      this.$v.$touch()
      if (this.$v.$invalid) { return }
      this.loading = true
      this.addNewOrder(this.formData).then(() => {
        this.$data.text = ''
        this.$emit('updateOrders')
        this.closeModal()
      }).catch((error) => {
        const message = getUserErrorMessage(error, 'Erro ao criar o pedido')
        this.setFeedback({ title: 'Erro ao criar o pedido', message: message, type: 'error' })
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>

<template>
  <modal :active="active" @close="closeModal" :width="'500px'">
    <modal-header title="Adicionar novo pedido" />
    <form :class="$classes['form-container']" @submit.prevent='handleAddOrder()'>
      <input-field label="Título do novo pedido" :label-uppercase="false" :placeholder="placeHolderName()"
        v-model="formData.name" :validation="$v.formData.name" />
      <small :class="$classes['help-text']">
        Deixe em branco, será gerado automaticamente com o N° do pedido e data/hora atual
      </small>
      <input-field label="Observações" :label-uppercase="false" placeholder="Escreva aqui" v-model="formData.obs"
        :validation="$v.formData.obs" />
      <div :class="$classes['form-actions']">
        <action variant="flat" color="secondary" type="button" uppercase bold @click="closeModal">
          <icon v-if="!$media.mobile" name="long-arrow-alt-left" btnIcon />
          Cancelar
        </action>
        <action variant="contained" color="primary" type="submit" :loading="loading" :disabled="loading">
          Adicionar
        </action>
      </div>
    </form>
  </modal>
</template>

<style module>
.form-container {
  display: flex;
  flex-direction: column;
}

.form-actions {
  margin-top: 60px;
  display: flex;
  justify-content: space-between;
}

.help-text {
  font-size: 10px;
  color: #a1a1a1;
  margin-bottom: 10px;
}
</style>
